<template>
   <svg
      name="light-exclamation-circle"
      viewBox="0 0 12 11"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
   >
      <path
         d="M6 1C8.48528 1 10.5 3.01472 10.5 5.5C10.5 7.98528 8.48528 10 6 10C3.51472 10 1.5 7.98528 1.5 5.5C1.5 3.01472 3.51472 1 6 1ZM11.5 5.5C11.5 2.46243 9.03757 0 6 0C2.96243 0 0.5 2.46243 0.5 5.5C0.5 8.53757 2.96243 11 6 11C9.03757 11 11.5 8.53757 11.5 5.5Z"
      />
      <path
         d="M6.00879 4.30859C5.73265 4.30859 5.50879 4.53245 5.50879 4.80859V7.57483C5.50879 7.85097 5.73265 8.07483 6.00879 8.07483C6.28493 8.07483 6.50879 7.85097 6.50879 7.57483V4.80859C6.50879 4.53245 6.28493 4.30859 6.00879 4.30859Z"
      />
      <path
         d="M6.00879 2.83984C6.28493 2.83984 6.50879 3.0637 6.50879 3.33984L6.50879 3.64468C6.50879 3.92082 6.28493 4.14468 6.00879 4.14468C5.73265 4.14468 5.50879 3.92082 5.50879 3.64468L5.50879 3.33984C5.50879 3.0637 5.73265 2.83984 6.00879 2.83984Z"
      />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
